import SSRIcon from '@ingka/ssr-icon';
import pin from '@ingka/ssr-icon/paths/location-pin';
import store from '@ingka/ssr-icon/paths/store';
import warning from '@ingka/ssr-icon/paths/warning-triangle';
import { isServiceType, serviceTypes } from '@repo/types/service';

interface Props {
    serviceType: string | undefined;
}

const locationIcons = {
    [serviceTypes.PUP]: pin,
    [serviceTypes.PUOP]: pin,
    [serviceTypes.LOCKER]: pin,
    [serviceTypes.CLICK_COLLECT_STORE]: store,
    [serviceTypes.HOME_DELIVERY]: pin,
} as const;

export const ArticleDeliveryAddressIcon = ({ serviceType }: Props) => {
    const iconPath = isServiceType(serviceType) ? locationIcons[serviceType] : warning;

    const testIdString = `delivery-address-icon-${!serviceType ? 'warning' : serviceType === serviceTypes.CLICK_COLLECT_STORE ? 'store' : 'pin'}`;

    return <SSRIcon paths={iconPath} data-testid={testIdString} />;
};
